import type { TFunction } from 'i18next'

import type { ConfiguredProductUnit, ProductUnit } from '../types/productUnit'
import { getProductUnitName } from './getProductUnitName'

// Resolves each standard unit's backend-sent label into the current language, leaving custom units untouched
export const getConfiguredProductUnits = (units: ProductUnit[] | undefined, t: TFunction): ConfiguredProductUnit[] =>
  (units ?? []).map((unit) => ({ ...unit, name: getProductUnitName(unit, t) }))
